import { FunctionComponent } from 'react'
import { CardProps } from './Card.model'

export const Card: FunctionComponent<CardProps> = ({ children, title }) => (
  <div className="p-4 rounded-xl shadow-md border border-shades-6 w-full bg-white">
    {title && <h3 className="text-lg font-semibold text-shades-2 mb-2">{title}</h3>}
    {children}
  </div>
)
